/**
 * @method domDefined
 * @description Identifies whether the window and document objects have been instantiated.
 * @param callback ?Function
 * @returns bool|any
 */
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const domDefined = (callback?: Function): boolean | any => {
	const defined = typeof window !== 'undefined' && typeof document !== 'undefined';
	if (defined && typeof callback === 'function') {
		return callback();
	}
	return defined;
};
